var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reason-rejection',{attrs:{"rejectionType":'Poda'},on:{"showHideLoading":_vm.showHideLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }